import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Title = ({ title }) => {
  return (
    <section id="hero" className="inner-banner d-flex align-items-center mt-5">
      <Container>
        <Row className="gy-4">
          <Col lg={12} className="d-flex flex-column justify-content-center">
            <h2 className="text-center pt-2">{title}</h2>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Title
